var exports = {
  "WW": "columnListNav__AJPq_u",
  "A$": "headingGroup__PJ8g2e",
  "Yg": "groupHeading__ptYkr4",
  "pW": "leadingVisual__6MIdsq",
};

module.exports = exports;
